<template>
  <fieldset v-if="subStep === 1" class="app-input-group registration-sub-step">
    <legend>
      <p v-if="config.intro?.title" class="title-txn">{{ config.intro.title }}</p>
      <span v-if="config.intro?.subtitle">{{ config.intro.subtitle }}</span>
    </legend>
    <div v-for="opt in config.options" :key="`sub-${opt.id}`" class="type-class">
      <label :for="`sub${opt.id}`" class="visit-type">
        <input
          type="radio"
          name="subOption"
          :id="`sub${opt.id}`"
          :value="opt.id"
          :checked="modelValue === opt.id"
          @change="$emit('update:modelValue', opt.id)"
        />
        <span class="res-visit-type">{{ opt.label }}</span>
      </label>
    </div>
  </fieldset>
  <section v-if="subStep === 2" class="registration-oca-notice" aria-live="polite">
    <p>{{ config.ocaDescriptions?.[modelValue] || '' }}</p>
    <a :href="ocaUrl" target="_blank" rel="noopener">
      {{ config.ocaLabels?.[modelValue] || '' }}
      <img src="@ridmv/web-themes/images/icons/external-link-alt-solid.svg" alt="" aria-hidden="true" />
      <span class="sr-only">(opens in a new tab)</span>
    </a>
  </section>
</template>


<script setup>
import { computed } from 'vue';

const props = defineProps({
  config: { type: Object, required: true },
  subStep: { type: Number, required: true },
  modelValue: { type: Number, default: null },
});
defineEmits(['update:modelValue']);

const ocaUrl = computed(() => {
  const key = props.config.ocaLinkConfigKey;
  return key && window.config[key] ? window.config[key] : '#';
});
</script>

<style lang="scss" scoped>
.title-txn{
  font-weight: 200;
}
.type-class {
  .visit-type{
    display: flex;
    gap: 0.5em;
    font-weight: 200;
    align-items: center;
  }
}

.registration-oca-notice{
  margin-bottom: 10em;
  img{
    margin-left: 0.5em;
    width: 1rem;
  }
}
</style>